<template>
  <div>
    <el-row>
      <el-col :span="3">
        <YearsComponent @change="onYearChange" :disabled="loadingData" />
      </el-col>
      <el-col :span="3">
        <MonthsComponent
          :initial="filters.Month"
          @change="onMonthChange"
          :isDisabled="loadingData"
        />
      </el-col>
      <el-col :span="3">
        <WeeksOfMonthComponent
          :initial="ActualWeek"
          :Year="filters.Year"
          :Month="filters.Month"
          @change="onWeekChange"
          :disabled="loadingData"
        />
      </el-col>
      <el-col :span="3">
        <TypeTasks :disabled="loadingData" @type-change="onTypeChange" />
      </el-col>
      <el-col :span="3">
        <DirectionSelector
          :initialDirection="filters.Direction"
          @selection-change="OnDirectionSelected"
          :isDisabled="loadingData"
        />
      </el-col>
      <el-col :span="3">
        <DepartmentsComponent
          :initialDirection="filters.Direction"
          :initialDeparment="filters.Deparment"
          :DirecctionID="filters.Direction"
          fieldSize="mini"
          @selectionChange="OnDeparmentSelected"
          :isDisabled="loadingData"
        />
      </el-col>
      <el-col :span="3">
        <EmployeeSelector
          :DireccionParams="filters.Direction"
          :DeparmentParams="filters.Deparment"
          :CurrentEmployee="filters.Responsible"
          placeholder="Responsable"
          @selection-change="OnResponsibleSelected"
          :disabled="loadingData"
        />
      </el-col>
    </el-row>
    <el-row>
      <rabbey-table-3
        :border="true"
        :stripe="true"
        :actions="TaskActions"
        @rtable-push-action="handlePushAction"
        :loading="loadingData"
        :data="FilteredTasks"
        :columns="TaskColumns"
        show-summary
        sum-text="Tiempo Total"
        :summary-method="getSummaries"
        page_Size="500"
        :pageSizes="[500, 1000]"
      />
    </el-row>
    <TasksAndRequestsList
      :dialogVisibleProp="dialogVisible"
      :rowData="selectedRowData"
      :ColumnData="selectedColumnData"
      :filters="filters"
      @CloseTaskListDialog="dialogVisible = $event"
    />
  </div>
</template>

<script>
import { columns } from "@/columns/ProductiveHoursReport/ProductivesHoursColumns";
import YearsComponent from "@/components/Global_System/YearsComponent";
import MonthsComponent from "@/components/Global_System/MonthsComponent";
import WeeksOfMonthComponent from "@/components/Global_System/WeeksOfMonthComponent";
import TypeTasks from "@/components/ProductivesHoursReport/TypeTasks";
import DirectionSelector from "@/components/Company/DirectionSelector";
import DepartmentsComponent from "@/components/Company/DepartmentsComponent";
import EmployeeSelector from "@/components/Company/EmployeeSelector";
import TasksAndRequestsList from "@/components/ProductivesHoursReport/TasksAndRequests/TasksAndRequestsList";
const actualYear = new Date().getFullYear();
const actualMonth = new Date().getMonth() + 1;

export default {
  name: "ProductivesHoursReport",
  components: {
    YearsComponent,
    MonthsComponent,
    WeeksOfMonthComponent,
    TypeTasks,
    DirectionSelector,
    DepartmentsComponent,
    EmployeeSelector,
    TasksAndRequestsList
  },
  data() {
    return {
      // Define your component's data properties here
      columns: columns(this),
      actions: [],
      items: [],
      loadingData: false,
      filters: {
        Year: actualYear,
        Month: actualMonth,
        Week: 1,
        Type: "",
        Direction: 0,
        Deparment: 0,
        Responsible: 0
      },
      dialogVisible: false,
      selectedRowData: {},
      selectedColumnData: {}
    };
  },
  computed: {
    // Define your component's computed properties here
    FilteredTasks() {
      // Return filtered tasks based on some criteria
      return this.items; // Placeholder
    },
    TaskColumns() {
      return this.columns; // Placeholder
    },
    TaskActions() {
      return this.actions; // Placeholder for actions
    },
    ActualMonth() {
      return this.filters.Month;
    },
    ActualWeek() {
      return this.filters.Week;
    }
  },
  created() {
    // Lifecycle hook when component is mounted
    this.filters.Week = this.getWeekOfMonth(new Date(), 0);
    this.getTasksForReport();
  },
  methods: {
    // Define your component's methods here
    handlePushAction(/*action*/) {
      // Handle the action pushed from the table
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (column.property === "OverallProductivityPercentage") {
          sums[index] =
            (
              (data
                .reduce((acc, item) => acc + (item["TotalClosedHours"] || 0), 0)
                .toFixed(2) /
                data
                  .reduce((acc, item) => acc + (item["TotalHours"] || 0), 0)
                  .toFixed(2)) *
              100
            ).toFixed(2) + " %";
        } else {
          sums[index] = data
            .reduce((acc, item) => acc + (item[column.property] || 0), 0)
            .toFixed(2);
        }
      });
      return sums;
    },
    async getTasksForReport() {
      // Fetch or compute tasks for the report
      this.loadingData = true;
      await this.$http
        .get("api/ReporteGestion/Get_Productive_Hours_Report", {
          params: {
            ResponsableID: this.filters.Responsible,
            DirecctionID: this.filters.Direction,
            DeparmentId: this.filters.Deparment,
            Year: this.filters.Year,
            Month: this.filters.Month,
            WeekOnMothSelected: this.filters.Week,
            Type: this.filters.Type
          }
        })
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.error("Error fetching tasks:", error);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    getWeekOfMonth(date = new Date(), startOfWeek = 0) {
      // Clone the date to avoid mutating the original
      const currentDate = new Date(date);
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();

      // First day of the month
      const firstDay = new Date(year, month, 1);
      const firstDayOfWeek = firstDay.getDay();

      // Normalize startOfWeek: Sunday = 0, Monday = 1, ..., Saturday = 6
      const offset = (7 + firstDayOfWeek - startOfWeek) % 7;

      // Calculate the adjusted day index
      const adjustedDate = currentDate.getDate() + offset;

      // Compute week number (1-based)
      return Math.ceil(adjustedDate / 7);
    },
    async onYearChange(year) {
      this.actualMonth = 1;
      // this.TabName = 1;
      this.filters.Year = year;
      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async onMonthChange(month) {
      // this.TabName = 1;
      this.filters.Month = month;

      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async onWeekChange(week) {
      // this.TabName = 1;
      this.filters.Week = week;
      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async onTypeChange(type) {
      // this.TabName = 1;
      this.filters.Type = type;
      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async OnDirectionSelected(val) {
      this.filters.Direction = val;
      await this.getTasksForReport();
      //this.GetDataForReport();
    },
    async OnDeparmentSelected(val) {
      this.filters.Deparment = val;
      await this.getTasksForReport();
    },
    async OnResponsibleSelected(val) {
      this.filters.Responsible = val;
      await this.getTasksForReport();
      // this.TabName = 1;
      // await this.KnowIfIsHisSupervisor(val);
      // await this.ReorderTasksMethod();
      // await this.GetRequestTasksData();
      //this.GetDataForReport();
    },
    OpenDialodDetailList(column, row) {
      console.log("OpenDialodDetailList column: ", column);
      console.log("OpenDialodDetailList row: ", row);
      this.selectedRowData = row;
      this.selectedColumnData = column;
      this.dialogVisible = true;
    }
  }
};
</script>

<style></style>
